module.exports = __webpack_public_path__ + "img/telegram.721e620e.svg";